module.exports = __webpack_public_path__ + "static/img/7.4b8b129.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/7.png
// module id = rZ3m
// module chunks = 0